export default __webpack_public_path__ + "static/1248-c668086f6633827cd8ace637f86837bd.gif";